import { useCallback, useEffect, useRef, useState } from 'react';

import {
  getTariffTabsConfig,
  TariffTabsConfig,
} from '../../../api/requests/settings';

/**
 * Lee del backend si las pestañas Subsidios y Convenios están habilitadas
 * para el tenant. Mientras carga (o si falla), ambas se consideran ocultas
 * (default false), coherente con el comportamiento del backend.
 */
export function useTariffTabsConfig() {
  const [isLoading, setIsLoading] = useState(true);
  const [config, setConfig] = useState<TariffTabsConfig>({
    subsidiesEnabled: false,
    partnershipsEnabled: false,
  });
  const alreadyFetched = useRef(false);

  const fetchConfig = useCallback(async () => {
    const { data, error } = await getTariffTabsConfig();
    if (!error && data) {
      setConfig(data);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!alreadyFetched.current) {
      alreadyFetched.current = true;
      fetchConfig();
    }
  }, [fetchConfig]);

  return { isLoading, config };
}
